import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import AuditAction from '@/audit//components/AuditAction';
import { roleUrl } from '@/constants/urls';
import { readStates, states } from '@/constants/lifecycle';
import EditAction from '@/components/ribbon-actions/EditAction';
import { roleManagementAccessControl } from '../helper';
import {
  editRole,
} from '../actions';
import CancelRoleAction from './CancelRoleAction';
import SaveRoleAction from './SaveRoleAction';
import DuplicateRoleAction from './DuplicateRoleAction';
import RoleActionsAction from '../roleactions/containers/RoleActionsAction';

const RoleActions = ({
  code,
  category,
  allowCreate,
  allowEdit,
  allowRoleActionsEdit,
  showEdit,
  allowAudit,
  url,
  isEditing,
  readStatus,
}) => (
  <>
    {allowEdit && !isEditing && (
    <EditAction
      onClick={() => showEdit(category, code)}
      disabled={readStatus !== states.SUCCESS}
    />
    )}
    {allowEdit && isEditing && (<CancelRoleAction code={code} category={category} />)}
    {allowEdit && (<SaveRoleAction code={code} category={category} isEditing={isEditing} />)}
    {allowCreate && (<DuplicateRoleAction code={code} category={category} />)}
    {allowAudit && (<AuditAction baseUrl={url} />)}
    {allowRoleActionsEdit && (<RoleActionsAction code={code} category={category} />)}
  </>
);

const mapStateToProps = ({
  auth: { role },
  roles: { roles },
}, { category, code }) => {
  const item = findResult(roles, category, code) || {
    isEditing: false, system: true, ...readStates, code,
  };

  return (
    {
      ...roleManagementAccessControl(role, item),
      isEditing: item.isEditing,
      url: roleUrl(item, '#'),
      readStatus: item.readStatus,
    }
  );
};

const mapDispatchToProps = {
  showEdit: editRole,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleActions);
